
// bp-atc v7.2 - FIXED: cart_add_url was /cart/add (old format), now uses /cart/add.js (AJAX API)
// Each click adds +1 to badge immediately
(function() {
  var S = '.product-item, .card-wrapper, .product-card';
  var PC = {};
  
  function ufc(count) {
    var q = 0;
    // Handle direct number, API response object, or CustomEvent
    if (typeof count === 'number') {
      q = count;
    } else if (count && count.item_count !== undefined) {
      q = count.item_count;
    } else if (count && count.detail && count.detail.item_count !== undefined) {
      q = count.detail.item_count;
    } else {
      // Read from badge element
      var e = document.querySelector('.bp-fcbg');
      if (e) {
        var txt = e.textContent.trim();
        q = parseInt(txt);
        if (isNaN(q)) q = 0;
      }
      // Try header if badge was 0
      if (q === 0) {
        var h = document.querySelector('.cartCount, [data-cart-count]');
        if (h) {
          var ht = h.textContent.trim();
          q = parseInt(ht);
          if (isNaN(q)) q = 0;
        }
      }
    }
    // Force-update badge with clean number
    var e = document.querySelector('.bp-fcbg');
    if (e) e.textContent = q;
    // Show/hide floating cart
    var d = document.querySelector('.bp-fc');
    if (d) { d.style.display = q > 0 ? 'flex' : 'none'; }
    // Update header cart count
    var countSpan = document.querySelector('.cartCount, [data-cart-count]');
    if (countSpan) countSpan.textContent = q;
  }
  
  function atcBP(vid, btn) {
    btn.classList.add('loading');
    var s = btn.querySelector('svg'); if (s) s.style.opacity = '0';
    // MUST use '/cart/add.js' (AJAX API) — window.routes.cart_add_url is '/cart/add' which expects old format
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(vid), quantity: 1 })
    }).then(function(r) {
      if (!r.ok) throw Error();
      return r.json();
    }).then(function(d) {
      btn.classList.remove('loading');
      btn.classList.add('added');
      // Show "✓ Added" text temporarily
      var origHTML = btn.innerHTML;
      btn.innerHTML = '<span style="font-size:9px;font-weight:600;color:#fff">✓</span>';
      if (s) s.style.opacity = '1';
      // Instant update: increment total by 1 (each click = 1 item)
      var currentBadge = document.querySelector('.bp-fcbg');
      var currentVal = currentBadge ? parseInt(currentBadge.textContent) || 0 : 0;
      ufc(currentVal + 1);
      document.dispatchEvent(new CustomEvent('cart-update', { detail: d }));
      setTimeout(function() { btn.classList.remove('added'); btn.innerHTML = origHTML; }, 2000);
    }).catch(function() {
      btn.classList.remove('loading');
      if (s) s.style.opacity = '1';
    });
  }
  
  function init() {
    // Create floating cart icon if not exists
    if (!document.querySelector('.bp-fc')) {
      var f = document.createElement('div');
      f.className = 'bp-fc';
      f.innerHTML = '<button class="bp-fcb"><svg viewBox="0 0 24 24"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg><span class="bp-fcbg">0</span></button>';
      document.body.appendChild(f);
      f.onclick = function(e) {
        e.preventDefault();
        // Click the header cart icon to trigger theme's cart sidebar
        var cartIcon = document.querySelector('.header__icon--cart, [data-cart-sidebar], [data-open-cart], a[href*="/cart"]');
        if (cartIcon) {
          cartIcon.click();
        } else {
          // Fallback: navigate to cart page
          window.location.href = '/cart';
        }
      };
      ufc();
    }
    
    // Add ATC buttons to product cards
    document.querySelectorAll(S).forEach(function(c) {
      var existing = c.querySelector('.bp-sw');
      if (existing && existing.querySelector('.bp-sb')) return;
      if (existing) existing.remove();
      
      var h = c.getAttribute('data-product-handle');
      if (!h) {
        var j = c.getAttribute('data-json-product');
        if (j) { try { var p = JSON.parse(j); if (p.handle) h = p.handle; } catch(e) {} }
      }
      if (!h) {
        var l = c.querySelector('.card-title a, .card-title, .product-title a, a.card-title, a[href*="/products/"]');
        if (l) { var hr = l.getAttribute('href'); if (hr) { var m = hr.match(/\/products\/([^?#]+)/); if (m) h = m[1].split('?')[0]; } }
      }
      if (!h) return;
      
      var w = document.createElement('div'); w.className = 'bp-sw';
      var b = document.createElement('button'); b.className = 'bp-sb';
      b.setAttribute('aria-label', 'Add to Cart');
      b.innerHTML = '<svg viewBox="0 0 24 24"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
      
      b.onmousedown = function(e) {
        e.stopPropagation();
        e.preventDefault();
        // Close any popup that might appear
        var popups = document.querySelectorAll('.halo-product-list-view-popup, .halo-popup, [class*="quick-view"], [class*="quick-shop"]');
        popups.forEach(function(p) { p.style.display = 'none'; });
        // Try data-json-product for variant ID first
        var j = c.getAttribute('data-json-product');
        if (j) {
          try { var p = JSON.parse(j); if (p.variants && p.variants[0] && p.variants[0].id) { atcBP(p.variants[0].id, this); return; } } catch(ex) {}
        }
        // Fallback: fetch product JSON
        this.classList.add('loading');
        var svg = this.querySelector('svg'); if (svg) svg.style.opacity = '0';
        fetch(window.location.origin + '/products/' + h + '.js')
          .then(function(r) { return r.json(); })
          .then(function(p) {
            var v = p.variants && p.variants[0];
            if (v) atcBP(v.id, b);
            else { b.classList.remove('loading'); if (svg) svg.style.opacity = '1'; }
          }).catch(function() {
            b.classList.remove('loading'); if (svg) svg.style.opacity = '1';
          });
      };
      
      w.appendChild(b);
      var ia = c.querySelector('.card-product__wrapper, .card-product');
      if (ia) { ia.style.position = 'relative'; ia.appendChild(w); }
      else { c.style.position = 'relative'; c.insertBefore(w, c.firstChild); }
    });
  }
  
  init();
  setTimeout(init, 1000);
  setTimeout(init, 3000);
  document.addEventListener('cart-update', ufc);
  new MutationObserver(function() { init(); }).observe(document.body, { childList: true, subtree: true });
})();
